import { Button } from "react-bootstrap";
import { useState } from "react";
import PopupWrapper from "../../components/PopupWrapper";
import AddMenuItem from "../../components/AdminSidebarMenuItemComp/AddMenuItem";
import CommonGrid from "../../components/CommonGrid";
import { SpinnerBlock } from "../../Utils/CustomComponent";

const AdminSidebarMenuItems = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [refreshTable, setRefreshTable] = useState(false);
  const [tableData, setTableData] = useState([]);
  return (
    <div style={{ overflowY: "scroll" }}>
      <section
        className=" rounded"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <div className="d-flex justify-content-between mt-4 bg-white pb-4">
          <h2 className="bg-light p-4">Sidebar Menu Items</h2>
          <Button
            className="text-white me-5 mt-5"
            onClick={() => {
              setShowPopup(true);
            }}
          >
            Add Item
          </Button>
          {showPopup && (
            <PopupWrapper
              title={
                <h2 className="p-4 font-weight-bold text-dark">
                  Add Menu Item
                </h2>
              }
              Component={
                <AddMenuItem
                  close={() => setShowPopup(false)}
                  refreshTable={() => setRefreshTable(!refreshTable)}
                />
              }
              toShow={showPopup}
              closeEventHandler={() => {
                setShowPopup(false);
              }}
            />
          )}
        </div>
        <div className="p-4 col-sm-12">
          {tableData ? (
            <CommonGrid
              className={"loans_in_workout bg-white col-sm-12"}
              title={"Sidebar Menu Items"}
              gridColumns={gridColumns_adminMenuItems}
              columnData={tableData}
            />
          ) : (
            <SpinnerBlock />
          )}
        </div>
      </section>
    </div>
  );
};

export default AdminSidebarMenuItems;
const gridColumns_adminMenuItems = [
  {
    field: "menu_item",
    title: "Menu Item Name",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "Mod Level",
    title: "Mod Level",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "Parent Mod ID",
    title: "Parent Mod ID",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "Mod Link",
    title: "Mod Link",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "Mod Type",
    title: "Mod Type",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "Mod Description",
    title: "Mod Description",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "Mod Order",
    title: "Mod Order",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "Is Active",
    title: "Is Active",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "Created",
    title: "Created",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "Created by",
    title: "Created by",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "Updated",
    title: "Updated",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "Updated By",
    title: "Updated By",
    style: { width: "10%", wordBreak: "break-all" },
  },

];
